import { useEffect } from "react";

export function useVersionFavicon(pathname: string) {
  const general =
    pathname === "/workspace/general" ||
    pathname.startsWith("/workspace/general/");
  const flagship =
    pathname === "/workspace" || pathname.startsWith("/workspace/");
  const href = general
    ? "/favicon-general.svg"
    : flagship
      ? "/favicon-flagship.svg"
      : "/favicon-site.svg";

  useEffect(() => {
    const existing = document.querySelector<HTMLLinkElement>(
      'link[rel="icon"][type="image/svg+xml"]',
    );
    const icon = existing ?? document.createElement("link");
    const originalHref = icon.getAttribute("href");
    icon.rel = "icon";
    icon.type = "image/svg+xml";
    icon.href = href;
    if (!existing) document.head.appendChild(icon);

    return () => {
      if (!existing) icon.remove();
      else if (originalHref === null) icon.removeAttribute("href");
      else icon.setAttribute("href", originalHref);
    };
  }, [href]);

  useEffect(() => {
    const fallback = document.querySelector<HTMLLinkElement>(
      'link[rel="icon"][sizes="32x32"]',
    );
    if (!fallback) return;
    const originalHref = fallback.getAttribute("href");
    const originalType = fallback.getAttribute("type");
    fallback.href = flagship ? "/favicon.ico" : "/favicon-site.png";
    if (!flagship) fallback.type = "image/png";
    else fallback.removeAttribute("type");

    return () => {
      if (originalHref === null) fallback.removeAttribute("href");
      else fallback.setAttribute("href", originalHref);
      if (originalType === null) fallback.removeAttribute("type");
      else fallback.setAttribute("type", originalType);
    };
  }, [flagship]);
}
